import { createSlice } from "@reduxjs/toolkit";

const initialBook = {
  name: "",
  author: "",
  publisher: "",
  pageNumber: 1,
  explanation: ""
};

const initialBookFinishing = {
  date: "",
  sections: [],
};

const initialBooksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  today: "",
  book: initialBook,
  bookFinishing: initialBookFinishing
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const teacherBookSlice = createSlice({
  name: "teacherBooks",
  initialState: initialBooksState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getBooks
    booksFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getBook
    bookFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.book = action.payload.entity;
    },
    // getBookFinishing
    bookFinishingFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.bookFinishing = action.payload.entity;
    },
    // getSectionsAndDate
    sectionsAndDateFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.today = entity.date;
      state.sections = entity.sections;
    },
    // getSectionStudentAndBooks
    sectionStudentAndBooksFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.students = entity.students;
      state.sectionBooks = entity.books;
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getSectionBooks
    sectionBooksFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sectionBooks = entities;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.studentBooks = [];
      entities.forEach(entity => state.studentBooks.push({ id: entity.id }));
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanSectionBooks
    sectionBooksStateCleaned: (state) => {
      state.sectionBooks = undefined;
    },
    // cleanBooksState
    booksStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.students = undefined;
      state.book = initialBook;
      state.bookFinishing = initialBookFinishing;
    }
  }
});